/* eslint-disable eqeqeq */
import Dexie from "dexie";
import { getChatMessages } from "../app/services/api/apiManager";
const indexedDB = new Dexie("MaxChats");

// Define schema
indexedDB.version(1).stores({
  chats:
    "chatId, name, lastMessage,otherUserId,picPath, createdDate,userOnline,userNickName,unreadCount,lastSeen,isHide,isMute,isFav,conversationType,sortAccordingToLastSMS, deleted, userData,userDeleted, isExternal,isAutoforward,eventDate,lastCall", // Use 'chatId' as the key
  messages:
    "[chatId+messageId], conversationId, status, senderId, isDraft, senderProfilePic, senderName, messageContent, replyMessage, createdDate, attachments, modifiedDate, seenUsers, reactions, deleted,event,userContactExists",
  events: "[conversationId+eventDateTime], eventMessage, eventDateTime",
  callHistory:
    "callId,callStatus,callTitle,callType,conversationId,createdBy,Deleted,duration,endTime,groupPicPath,participants",
  participants:
    "[conversationId+userId], conversationParticipantId, userId, firstName, lastName, profilePicPath, isContact, isBlocked",
});

export const saveChatListToIndexedDB = async (chatList) => {
  const mappedChats = chatList?.map((chat) => ({
    ...chat,
    chatId: chat.chatId,
    lastMessage: chat.lastMessage,
    sortAccordingToLastSMS: chat?.lastMessage?.createdDate,
    // normalize to camelCase `isHide`, preserve legacy `ishide` if present
    isHide: chat?.isHide ?? chat?.ishide ?? false,
    isMute: chat?.isMute,
    isFav: chat?.isFav,
    deleted: chat?.deleted === undefined ? false : chat?.deleted,
    unreadCount: chat?.unreadCount,
    userDeleted: chat?.userDeleted,
    isExternal: chat?.isExternal === undefined ? false : chat?.isExternal,
    isAutoforward:
      chat?.isAutoforward === undefined ? false : chat?.isAutoforward,
    eventDate: chat?.eventDate,
    lastCall: chat?.lastCall,
  }));
  try {
    const resp = await indexedDB.chats.bulkPut(mappedChats); // Store the mapped array
    return resp;
  } catch (error) {
    console.error("Error saving chats:", error);
  }
};
export const fetchChatListIndexedDB = async () => {
  return await indexedDB.chats
    ?.orderBy("sortAccordingToLastSMS")
    ?.filter((chat) => chat.deleted !== true && chat.isExternal !== true)
    ?.reverse()
    ?.toArray();
};

export const sortChatListAccordingToFav_LastMSG = (chatList) => {
  return chatList.sort((a, b) => {
    // 1. User match priority
    const isAUser = a.otherUserId == null && a.conversationType == "Single";
    const isBUser = b.otherUserId == null && b.conversationType == "Single";
    if (isAUser && !isBUser) return -1;
    if (isBUser && !isAUser) return 1;

    // 2. Favorites priority
    if (a.isFav === true && b.isFav !== true) return -1;
    if (b.isFav === true && a.isFav !== true) return 1;

    // 3. Latest activity priority (eventDate, lastMessage.createdDate, or lastCall.createdDate)
    const dateA = new Date(
      Math.max(
        new Date(a.eventDate || 0).getTime(),
        new Date(a.lastMessage?.createdDate || 0).getTime(),
        new Date(a.lastCall?.createdDate || 0).getTime()
      )
    );

    const dateB = new Date(
      Math.max(
        new Date(b.eventDate || 0).getTime(),
        new Date(b.lastMessage?.createdDate || 0).getTime(),
        new Date(b.lastCall?.createdDate || 0).getTime() // Added lastCall.createdDate
      )
    );
    return dateB - dateA; // Sort by descending date (newest first)
  });
};
// for rerendering tha chatlist-message-section
export const fetchChatList_IndexDB_SortIt = async (chatlist) => {
  const cachedCHTLIST = await sortChatListAccordingToFav_LastMSG(chatlist);
  return cachedCHTLIST?.map((items) => {
    return {
      chatId: items?.chatId,
      name: items?.name,
      lastMessage: items?.lastMessage,
      createdDate: items?.createdDate,
      userOnline: items?.userOnline,
      userNickName: items?.userNickName,
      lastSeen: items?.lastSeen,
      // normalized field used across app
      isHide: items?.isHide ?? items?.ishide ?? false,
      isMute: items?.isMute,
      isFav: items?.isFav,
      deleted: items?.deleted,
      conversationType: items?.conversationType,
      otherUserId: items?.otherUserId,
      picPath: items?.picPath,
      unreadCount: items?.unreadCount,
      userDeleted: items?.userDeleted,
      isExternal: items?.isExternal === undefined ? false : items?.isExternal,
      isAutoforward:
        items?.isAutoforward === undefined ? false : items?.isAutoforward,
      eventDate: items?.eventDate,
      lastCall: items?.lastCall,
    };
  }); // Retrieve all chats
};

export const saveCallEventsToIndexedDB = async (callEventsHistory) => {
  try {
    await indexedDB.callHistory.bulkPut(callEventsHistory);
  } catch (error) {
    console.error("Error saving events to IndexedDB:", error);
  }
};
export const getCallHistory_IndexedDb = async (conversationId) => {
  try {
    const callHistoryEvents = await indexedDB.callHistory
      .where("conversationId")
      .equals(conversationId)
      .toArray();

    return callHistoryEvents;
  } catch (error) {
    console.error("Error fetching call history by conversationId:", error);
    return [];
  }
};
export const saveAllMessagesToIndexedDB = async (chatId, newMessages) => {
  try {
    // Map messages to include chatId and ensure proper schema matching
    const mappedMessages = newMessages.map((msg) => ({
      ...msg,
      chatId, // Add chatId to associate messages with their chat
      messageId: msg.messageId, // Ensure this is unique
      conversationId: msg.conversationId,
      status: msg.status,
      senderId: msg.senderId,
      isDraft: msg.isDraft || false,
      senderProfilePic: msg.senderProfilePic,
      senderName: msg.senderName,
      messageContent: msg.messageContent,
      replyMessage: msg.replyMessage,
      createdDate: msg.createdDate,
      modifiedDate: msg.modifiedDate,
      seenUsers: msg.seenUsers,
      reactions: msg.reactions || [],
      deleted: msg.deleted || false,
      event: msg.event || [],
      userContactExists: msg.userContactExists,
    }));

    // Save all mapped messages to IndexedDB
    await indexedDB.messages.bulkPut(mappedMessages);
  } catch (error) {
    console.error("Error saving messages to IndexedDB:", error);
  }
};
export const fetchUnsend_Messages_IndexedDB = async () => {
  try {
    return await indexedDB.messages
      .filter((msg) => msg.status == null && msg.isDraft !== true)
      .toArray();
  } catch (error) {
    console.error("Error fetching pending messages:", error);
    return [];
  }
};
export const updateChatLastMessage_IndexedDB = async (chatId, lastMessage) => {
  try {
    const updated = await indexedDB.chats.update(chatId, {
      lastMessage: lastMessage,
      sortAccordingToLastSMS: lastMessage?.createdDate || new Date(),
      createdDate: lastMessage?.createdDate || new Date(),
    });

    if (updated) {
    } else {
      console.log("Chat not found");
    }
  } catch (error) {
    console.error("Error updating lastMessage:", error);
  }
};
export const fetchMessagesFromIndexedDB = async (chatId) => {
  try {
    return await indexedDB.messages
      .where("chatId")
      .equals(chatId)
      .filter((msg) => msg.deleted !== true) // Exclude deleted messages
      .toArray();
  } catch (error) {
    console.error("Error fetching messages from IndexedDB:", error);
    return [];
  }
};
//region to get SingleMessage
export const getMessageByChatIdAndMsgId_IndexedDB = async (
  chatId,
  messageId
) => {
  try {
    const message = await indexedDB.messages
      .where("chatId")
      .equals(chatId)
      .and((msg) => msg.messageId === messageId)
      .first();

    return message;
  } catch (error) {
    console.error("Error fetching message by chatId and messageId:", error);
    return undefined;
  }
};

// region update Message
export const updateMessageFromIndexed_DB = async (
  chatId,
  messageId,
  updatedMessageContent,
  attachments
) => {
  try {
    const updated = await indexedDB.messages.update([chatId, messageId], {
      messageContent: updatedMessageContent,
      modifiedDate: new Date(),
      attachments: attachments || [],
    });

    if (updated) {
      // Fetch the chat to check if this message is the lastMessage
      const currentChat = await indexedDB.chats.get(chatId);

      if (currentChat?.lastMessage?.messageId === messageId) {
        await indexedDB.chats.update(chatId, {
          lastMessage: {
            ...currentChat.lastMessage,
            messageContent: updatedMessageContent, // Update the last message content
            modifiedDate: new Date(),
          },
        });
      }
    } else {
      console.log("Message not found");
    }
  } catch (error) {
    console.error("Error updating record:", error);
  }
};

export const deleteMessageFrom_IndexedDB = async (chatId, messageId) => {
  try {
    const updated = await indexedDB.messages.update([chatId, messageId], {
      deleted: true,
    });

    if (updated) {
    } else {
      console.log("Record not found");
    }
  } catch (error) {
    console.error("Error updating record:", error);
  }
};

export const deleteMessage_From_IndexedDB_Parmanent = async (
  chatId,
  messageId
) => {
  try {
    await indexedDB.messages.delete([chatId, messageId]);
  } catch (error) {
    console.error("Error deleting message from IndexedDB:", error);
  }
};
export const deleteMultipleMessages_IndexedDB = async (chatId, messageIds) => {
  try {
    const updates = await messageIds.map(async (messageId) => {
      await indexedDB.messages.delete([chatId, messageId]);
    });

    await Promise.all(updates);
  } catch (error) {
    console.error("Error marking messages as deleted:", error);
  }
};
//region draft
export const saveDraftMessageToIndexedDB = async (chatId, draftMessage) => {
  try {
    const messageData = {
      chatId,
      messageId: draftMessage.messageId,
      conversationId: draftMessage.conversationId,
      senderId: draftMessage.senderId,
      messageContent: draftMessage.messageContent,
      createdDate: draftMessage.createdDate,
      isDraft: true, // Mark as draft
      attachments: draftMessage.attachments || [],
      deleted: draftMessage.deleted || false,
      isRead: draftMessage.isRead || false,
    };

    await indexedDB.messages.put(messageData); // Insert or update
  } catch (error) {
    console.error("Error saving draft message:", error);
  }
};
export const getUserContactExistsByChatId_IndexedDB = async (chatId) => {
  try {
    const messages = await indexedDB.messages
      .where("chatId")
      .equals(chatId)
      .filter((msg) => msg.deleted !== true)
      .sortBy("createdDate");

    if (messages.length === 0) return null;
    // Return the latest non-deleted message's userContactExists flag
    return messages[messages.length - 1]?.userContactExists;
  } catch (error) {
    console.error("Error getting userContactExists:", error);
    return null;
  }
};
export const updateUserContactExistsByChatId_IndexedDB = async (chatId) => {
  try {
    await indexedDB.messages
      .where("chatId")
      .equals(chatId)
      .modify((message) => {
        message.userContactExists = true;
      });
  } catch (error) {
    console.error("Error updating userContactExists field:", error);
  }
};
export const getAllChatsByOtherUserId_IndexedDB = async (otherUserId) => {
  try {
    const chats = await indexedDB.chats
      .where("otherUserId")
      .equals(otherUserId)
      .toArray(); // Returns all matching chats
    return chats;
  } catch (error) {
    console.error("Error fetching chats by otherUserId:", error);
    return [];
  }
};
//region events
export const saveEventsToIndexedDB = async (eventsArray) => {
  try {
    const mappedEvents = eventsArray.map((items) => ({
      conversationId: items.conversationId,
      eventMessage: items.eventMessage,
      eventDateTime: items.eventDateTime,
    }));

    await indexedDB.events.bulkPut(mappedEvents); // Insert or update multiple events
  } catch (error) {
    console.error("Error saving events to IndexedDB:", error);
  }
};
export const fetchEventsFromIndexedDB = async (conversationId) => {
  try {
    return await indexedDB.events
      .where("conversationId")
      .equals(conversationId)
      .sortBy("eventDateTime"); // Sort by date
  } catch (error) {
    console.error("Error fetching events:", error);
    return [];
  }
};
//region chat participants
export const saveParticipantsToIndexedDB = async (
  conversationId,
  participantsArray
) => {
  try {
    const mappedParticipants = participantsArray.map((participant) => ({
      conversationId, // Associate participant with a conversation
      conversationParticipantId: participant.conversationParticipantId,
      userId: participant.userId,
      firstName: participant.firstName,
      lastName: participant.lastName,
      profilePicPath: participant.profilePicPath,
      isContact: participant.isContact || false,
      isBlocked: participant.isBlocked || false,
    }));

    await indexedDB.participants.bulkPut(mappedParticipants);
  } catch (error) {
    console.error("Error saving participants to IndexedDB:", error);
  }
};
export const fetchParticipantsFromIndexedDB = async (conversationId) => {
  try {
    return await indexedDB.participants
      .where("conversationId")
      .equals(conversationId)
      .toArray();
  } catch (error) {
    console.error("Error fetching participants:", error);
    return [];
  }
};

export const deleteIndexDB = async (dbName) => {
  try {
    await Dexie.delete(dbName);
  } catch (error) {
    console.error(`DB Delete--->`, error);
  }
};

//region complex things updation
export const updateUserOnlineStatus_IndexedDB = async (
  otherUserId,
  isOnline
) => {
  try {
    // Find the chat where this user is involved
    const chat = await indexedDB.chats
      .where("otherUserId")
      .equals(otherUserId)
      .first();

    if (chat) {
      // Update the userOnline status in the chat entry
      const updated = await indexedDB.chats.update(chat.chatId, {
        userOnline: isOnline,
      });

      if (updated) {
      } else {
        console.log(`Chat not found for otherUserId: ${otherUserId}`);
      }
    } else {
      console.log(`No chat found for otherUserId: ${otherUserId}`);
    }
  } catch (error) {
    console.error("Error updating user online status:", error);
  }
};
export const updateChatName_IndexedDB = async (chatID, updatedChatName) => {
  try {
    // Update the userOnline status in the chat entry
    const updated = await indexedDB.chats.update(parseInt(chatID), {
      name: updatedChatName,
    });

    if (updated) {
    } else {
      console.log(`Chat not found for otherUserId: `);
    }
  } catch (error) {
    console.error("Error updating user online status:", error);
  }
};

export const updateMessageSeen_IndexedDB = async (
  chatId,
  messageId,
  seenUsers
) => {
  try {
    //for singleChat
    const updated = await indexedDB.messages.update([chatId, messageId], {
      seenUsers: seenUsers === "" ? [] : [seenUsers],
    });

    if (updated) {
    } else {
      console.log("Message not found");
    }
  } catch (error) {
    console.error("Error updating record:", error);
  }
};
export const updateMessageSeenGROUP_IndexedDB = async (
  chatId,
  messageId,
  seenUsers
) => {
  try {
    //for group chat
    const existingMessage = await indexedDB.messages.get([chatId, messageId]);
    if (existingMessage) {
      const updatedSeenUsers = Array.isArray(existingMessage.seenUsers)
        ? [...existingMessage.seenUsers]
        : [];

      // Check if userId already exists
      const alreadySeen = updatedSeenUsers.some(
        (u) => u.userId === seenUsers.userId
      );

      if (seenUsers && !alreadySeen) {
        updatedSeenUsers.push(seenUsers);
      }

      await indexedDB.messages.update([chatId, messageId], {
        seenUsers: updatedSeenUsers,
      });
    }
  } catch (error) {
    console.error("Error updating record:", error);
  }
};
export const getChatByOtherUserId_IndexedDB = async (otherUserId) => {
  try {
    const chat = await indexedDB.chats
      .where("otherUserId")
      .equals(otherUserId)
      .first(); // Returns the first matching chat
    return chat;
  } catch (error) {
    console.error("Error fetching chat by otherUserId:", error);
    return null;
  }
};
export const updateMessageReaction_IndexedDB = async (
  chatId,
  messageId,
  userId,
  emoji,
  reactorName,
  reactorPicUrl,
  msgReactionId
) => {
  try {
    const message = await indexedDB.messages.get([chatId, messageId]);

    if (!message) {
      console.warn("Message not found");
      return;
    }

    let updatedReactions = Array.isArray(message.reactions)
      ? [...message.reactions]
      : [];

    updatedReactions = updatedReactions.filter((r) => r.reactorId !== userId);
    updatedReactions.push({
      conversationId: chatId,
      messageId: messageId,
      messageReactionId: msgReactionId,
      proifle_Pic: reactorPicUrl,
      reaction: emoji,
      reactionRemoved: false,
      reactorId: userId,
      reactor_Name: reactorName,
    });
    await indexedDB.messages.update([chatId, messageId], {
      reactions: updatedReactions,
    });
  } catch (error) {
    console.error("Error updating reaction:", error);
  }
};
export const removeMessageReaction_IndexedDB = async (
  chatId,
  messageId,
  messageReactionId
) => {
  try {
    const message = await indexedDB.messages.get([chatId, messageId]);
    if (!message || !Array.isArray(message.reactions)) return;

    const updatedReactions = message.reactions.map((reaction) => {
      if (reaction.messageReactionId == messageReactionId) {
        return { ...reaction, reactionRemoved: true };
      }
      return reaction;
    });

    await indexedDB.messages.update([chatId, messageId], {
      reactions: updatedReactions,
    });
  } catch (error) {
    console.error("Error removing reaction:", error);
  }
};
export const getChatByChatIdAndUserId_IndexedDB = async (chatId, userId) => {
  try {
    const chat = await indexedDB.chats.get(chatId);
    if (chat && chat.userData?.userId == userId) {
      return chat;
    }
    return null;
  } catch (error) {
    console.error("Error fetching chat by chatId and userId:", error);
    return null;
  }
};
export const updateUserContactIdByOtherUserId_IndexedDB = async (
  otherUserId,
  newUserContactId,
  userNickName
) => {
  try {
    const chat = await indexedDB.chats
      .where("otherUserId")
      .equals(otherUserId)
      .first();
    if (!chat) {
      console.warn(`No chat found for otherUserId: ${otherUserId}`);
      return false;
    }
    const updated = await indexedDB.chats.update(chat.chatId, {
      userContactId: newUserContactId,
      userNickName: userNickName,
    });

    if (updated) {
      console.log(`userContactId updated for otherUserId: ${otherUserId}`);
      return true;
    } else {
      console.warn(`Update failed for chatId: ${chat.chatId}`);
      return false;
    }
  } catch (error) {
    console.error("Error updating userContactId by otherUserId:", error);
    return false;
  }
};
//region - Sync all new messages
export const resyncLatestMessages = async (chatId, userId, isAdmin) => {
  try {
    const response = await getChatMessages(userId, chatId, isAdmin, 1, 50);
    const newMessages = response?.data?.result || [];
    const updatedMessages = newMessages?.messages?.map((msg) =>
      msg?.replyMessage?.length > 0
        ? { ...msg, replyMessage: msg?.replyMessage[0] }
        : { ...msg, replyMessage: null }
    );
    if (updatedMessages?.length > 0) {
      await saveAllMessagesToIndexedDB(chatId, updatedMessages);
      await indexedDB.chats.update(chatId, (chat) => {
        return {
          ...chat,
          lastMessage: {
            createdDate: newMessages?.messages[0]?.createdDate,
            messageContent:
              newMessages?.messages[0]?.messageContent === ""
                ? "Qouted"
                : newMessages?.messages[0]?.messageContent,
            messageId: newMessages?.messages[0]?.messageId,
            isDraft: false,
          },
          eventDate: null,
          createdDate: newMessages?.messages[0]?.createdDate,
          unreadCount: newMessages?.unreadCount,
        };
      });
    }
  } catch (error) {
    console.error("Error in resyncLatestMessages:", error);
  }
};
// region - Apply Hide Status to IndexedDB
export const applyHideStatusToIndexedDB = async (
  chatId,
  isHide,
  chatData = null
) => {
  const sanitize = (obj) => {
    if (!obj) return obj;
    try {
      // remove functions, symbols and circular refs — keep plain data
      return JSON.parse(
        JSON.stringify(obj, (key, value) => {
          if (typeof value === "function" || typeof value === "symbol")
            return undefined;
          return value;
        })
      );
    } catch {
      // fallback: shallow copy only plain enumerable properties
      const out = {};
      Object.keys(obj || {}).forEach((k) => {
        const v = obj[k];
        if (v === null) out[k] = null;
        else if (["string", "number", "boolean"].includes(typeof v)) out[k] = v;
        else if (Array.isArray(v))
          out[k] = v.map((i) => (typeof i === "object" ? sanitize(i) : i));
        else if (typeof v === "object") out[k] = sanitize(v);
      });
      return out;
    }
  };

  try {
    const id =
      typeof chatId === "string" && /^\d+$/.test(chatId)
        ? parseInt(chatId, 10)
        : chatId;

    if (isHide === true) {
      // remove from DB
      await indexedDB.chats.delete(id);
    } else {
      // insert/update — require chatData
      if (!chatData)
        throw new Error("chatData required when setting isHide to false");

      // map only allowed fields and sanitize nested objects
      const mapped = {
        chatId: id,
        name: chatData?.name ?? null,
        lastMessage: sanitize(chatData?.lastMessage) ?? null,
        otherUserId: chatData?.otherUserId ?? null,
        picPath: chatData?.picPath ?? null,
        createdDate: chatData?.createdDate ?? null,
        userOnline: !!chatData?.userOnline,
        userNickName: sanitize(chatData?.userNickName) ?? null,
        unreadCount: chatData?.unreadCount ?? 0,
        lastSeen: chatData?.lastSeen ?? null,
        // normalize isHide and fallback legacy
        isHide: false,
        isMute: !!chatData?.isMute,
        isFav: !!chatData?.isFav,
        conversationType: chatData?.conversationType ?? null,
        sortAccordingToLastSMS:
          chatData?.lastMessage?.createdDate ??
          chatData?.sortAccordingToLastSMS ??
          null,
        deleted: !!chatData?.deleted,
        userData: sanitize(chatData?.userData) ?? null,
        userDeleted: !!chatData?.userDeleted,
        isExternal: !!chatData?.isExternal,
        isAutoforward: !!chatData?.isAutoforward,
        eventDate: chatData?.eventDate ?? null,
        lastCall: sanitize(chatData?.lastCall) ?? null,
      };

      await indexedDB.chats.put(mapped);
    }

    // return updated lists
    const raw = await fetchChatListIndexedDB();
    const normalized = await fetchChatList_IndexDB_SortIt(raw);
    const visible = normalized.filter(
      (c) => c.isHide !== true && c.deleted !== true
    );
    const hidden = normalized.filter(
      (c) => c.isHide === true && c.deleted !== true
    );

    return { all: normalized, visible, hidden };
  } catch (error) {
    console.error("applyHideStatusToIndexedDB error:", error);
    throw error;
  }
};
export default indexedDB;
